import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import es from './es.json';

const STORAGE_KEY = 'vw_lang';

function initialLanguage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'en' || stored === 'es') return stored;
  } catch (_) {}
  return (navigator.language || '').toLowerCase().startsWith('es') ? 'es' : 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    lng: initialLanguage(),
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

// Keep localStorage in sync so a logged-out visitor's toggle survives a reload, and so
// dashboards that call i18n.changeLanguage() after reading user_preferences don't get
// clobbered back to the browser default on the next load.
i18n.on('languageChanged', (lng) => {
  try { localStorage.setItem(STORAGE_KEY, lng); } catch (_) {}
});

export default i18n;
